import * as React from 'react';
export const GlobalSimpleIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
  >
    <path
      fill="#A8EA3A"
      d="M10 1.875A8.125 8.125 0 1 0 18.125 10 8.134 8.134 0 0 0 10 1.875Zm6.845 7.5h-3.111c-.14-2.852-1.239-4.87-2.14-6.063a6.89 6.89 0 0 1 5.252 6.063Zm-9.327 1.25h4.964c-.18 3.25-1.737 5.243-2.482 6.016-.746-.774-2.302-2.766-2.482-6.016Zm0-1.25c.18-3.25 1.737-5.243 2.482-6.016.746.776 2.302 2.768 2.482 6.016H7.518Zm.887-6.063c-.9 1.193-1.999 3.21-2.139 6.063H3.154a6.89 6.89 0 0 1 5.251-6.063Zm-5.251 7.313h3.112c.143 2.852 1.239 4.87 2.14 6.063a6.89 6.89 0 0 1-5.252-6.063Zm8.437 6.063c.901-1.193 1.997-3.21 2.14-6.063h3.112a6.89 6.89 0 0 1-5.248 6.063h-.004Z"
    />
  </svg>
);
